export default "__VITE_ASSET__v_pxh4fh__"